import { _axios } from '@/plugins/axios';

const assetResource = '/api/v1/asset';

export default {
  all: () => _axios.get(`${assetResource}/all`),
  // upload: data => _axios.post(`${assetResource}/upload`, data),
  delete: assetName => _axios.post(`${assetResource}/delete`, assetName),
  getBytes: assetName => _axios.post(`${assetResource}/get/bytes`, assetName),
  // updateMetadata: data => _axios.post(`${assetResource}/edit/metadata`, data),
  // getAsset: assetName => _axios.post(`${assetResource}/get`, assetName),
  // getAssetTypes: () => _axios.get(`${assetResource}/types`),
  // finalizeAsset: data => _axios.post(`${assetResource}/finalize`, data),
};
